/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  permit: {
    partner: {},
    user: {},
    product: {
      expirationDate: null,
    },
  },
  coordinates: [],
  error: null,
};

const getters = {
  permit: state => state.permit,
  selectedPermitId: state => (state.permit ? state.permit.id : null),
  error: state => state.error,
  coordinates: state => state.coordinates,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/permits/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  saveNewVehicle({ commit }, payload) {
    try {
      return Vue.http.post(`${process.env.BACKEND_API_URL}api/user/${payload.userId}/vehicle`, {
        vehicle_reg: payload.vehicle_reg,
        comment: payload.vehicleComment,
      });
    } catch (e) {
      commit(mTypes.DATA_ERROR, 'New vehicle saving error');
    }
  },
  updateVehicle({ commit }, payload) {
    try {
      const updateData = {
        comment: payload.vehicleComment,
      };
      if (payload.vehicleReg) {
        updateData.vehicleReg = payload.vehicleReg;
      }
      Vue.http.put(`${process.env.BACKEND_API_URL}api/user/${payload.userId}/vehicle/${payload.vehicleId}`, updateData);
    } catch (e) {
      commit(mTypes.DATA_ERROR, 'Vehicle updating error');
    }
  },
  savePermit({ commit }, payload) {
    const { permit, user } = payload;
    const path = `${user.data.selectedRole.role}s/${user.data.selectedRole.id}`;
    let request;

    if (permit.vehicleId) {
      delete permit.vehicle;
      delete permit.vehicle_reg;
      delete permit.vehicleComment;
      delete permit.vehicleReg;
    }

    if (permit.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/permits/${permit.id}`, permit);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/permits`, permit);
    }
    return request.then((response) => {
      commit(mTypes.DATA_STORED, response);
    })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  updatePermitVehicleReg({ commit }, payload) {
    const { permitId, vehicleReg, comment, user } = payload;
    const path = `${user.data.selectedRole.role}s/${user.data.selectedRole.id}`;
    const request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/permits/${permitId}/vehicle-reg`, {
      vehicleReg,
      comment,
      permitId,
      user
    });

    return request.then((response) => {
      commit(mTypes.DATA_ERROR, null);
    }).catch((response) => {
      commit(mTypes.DATA_ERROR, response);
    });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/permits/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  deleteBulk({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/permits/bulk`, { params: { ids: payload.ids, _method: 'DELETE' } })
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, permit) {
    state.permit = permit.data;
    state.coordinates = [];
    if (state.permit.product && state.permit.product.zones) {
      state.permit.product.zones.forEach(el => (el.coordinates
        ? state.coordinates.push(el.coordinates)
        : true));
    }
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.permit = {};
    state.coordinates = [];
  },
  [mTypes.DATA_STORED](state, permit) {
    state.permit = permit.data;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/permits/permit.js